<template>
  <div v-if="value" class="star-rating" :class="[size ? 'star-rating--' + size : '', type ? 'star-rating--' + type : '']">
    <label v-for="(rating, index) in ratings"
           :key="index"
           @click="$emit('setRating', $event.target.value)"
           @mouseover="$emit('startOver', index + 1)"
           @mouseout="$emit('startOut', $event.target.value)"
           class="star-rating__star"
           :class="{'is-selected': ((value >= rating) && value != null), 'is-disabled': disabled}">
      <input class="star-rating star-rating__checkbox"
             type="radio"
             :value="rating"
             :name="name"
             v-model="value"
             :disabled="disabled">
      <svg class="star-rating__svg"
           width="12"
           height="12"
           viewBox="0 0 12 12"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7951 4.67836L9.53019 6.85083C9.3177 7.05439 9.19516 7.42522 9.24538 7.71333L9.78014 10.7803C9.81257 10.9661 9.79449 11.1153 9.73064 11.1897C9.71844 11.204 9.68157 11.2469 9.58142 11.2469C9.51929 11.2469 9.4134 11.2305 9.26102 11.1514L6.4614 9.70314C6.33485 9.63792 6.17114 9.60178 6.00025 9.60178C5.82937 9.60178 5.66565 9.63792 5.53925 9.70314L2.73977 11.1514C2.58725 11.2305 2.48122 11.2469 2.41938 11.2469C2.31908 11.2469 2.28207 11.2038 2.27001 11.1897C2.20631 11.1153 2.18823 10.9661 2.22066 10.7802L2.75513 7.71333C2.80534 7.42522 2.68281 7.05439 2.47031 6.85083L0.205166 4.67836C0.0490581 4.52887 -0.024835 4.38136 0.00744836 4.28339C0.0398753 4.18571 0.187805 4.10906 0.403458 4.07815L3.53323 3.63052C3.82708 3.58846 4.1479 3.35935 4.27919 3.09764L5.679 0.307167C5.77542 0.114905 5.89551 0 5.99997 0C6.10442 0 6.22452 0.114764 6.32094 0.307167L7.72074 3.09764C7.85203 3.35935 8.17271 3.5886 8.46642 3.63052L11.5965 4.07815C11.8121 4.10906 11.9601 4.18571 11.9925 4.28339C12.0249 4.38108 11.9512 4.52887 11.7951 4.67836Z"/>
      </svg>
    </label>
    <span class="star-rating__value">{{ this.$attrs.title }}</span>
  </div>
</template>

<script>
export default {
  name: 'StarRating',
  props: {
    name: String,
    value: null,
    id: String,
    disabled: Boolean,
    required: Boolean,
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ratings: [1, 2, 3, 4, 5]
    }
  }
}
</script>

<style lang="sass" scoped>

%visually-hidden
  position: absolute
  overflow: hidden
  clip: rect(0 0 0 0)
  height: 1px
  width: 1px
  margin: -1px
  padding: 0
  border: 0

.star-rating
  display: flex
  align-items: center

.star-rating--medium
  .star-rating__svg
    width: 14px
    height: 14px

.star-rating--big
  .star-rating__star
    padding-left: 10px
    padding-right: 10px

  .star-rating__svg
    width: 25px
    height: 25px

.star-rating--adaptive .is-disabled
  &:not(:first-child)
    display: none

.star-rating__star
  display: inline-block
  padding-left: 0
  padding-right: 0
  line-height: 1

  &:first-child
    padding-left: 0

  &:last-child
    padding-right: 0

  &:hover
    cursor: pointer

  svg
    fill: #e7e7e7
    transition: .3s

  &.is-selected svg
    fill: #FFD700

  &.is-disabled:hover
    cursor: default

.star-rating__checkbox
  @extend %visually-hidden

.star-rating__value
  display: none

.star-rating--adaptive .star-rating__value
  display: inline
  color: $nd-label-color
  font-size: 12px
  line-height: 14px
  margin-left: 5px

.product-card
  .star-rating__star
    &:not(:first-child)
      display: none

    +mmin($tablet)

  .star-rating__value
    display: inline
    color: $nd-label-color
    font-size: 12px
    line-height: 14px
    margin-left: 5px

    +mmin($tablet)

</style>
